import React from "react";

interface DisclaimerBoxProps {
  disclaimerText?: string;
  linkText?: string;
  href?: string;
  showLink?: boolean;
}

const DisclaimerBox = ({
  disclaimerText,
  linkText,
  href,
  showLink = true,
}: DisclaimerBoxProps) => (
  <div className="disclaimer-box">
    <p>{disclaimerText}</p>
    {showLink && (
      <a
        className="terms-link"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          cursor: "pointer",
          paddingLeft: 3,
        }}
      >
        <p
          className="terms-text"
          style={{
            color: "#1D99A9",
            fontStyle: "italic",
            fontSize: 14,
          }}
        >
          {linkText}
        </p>
      </a>
    )}
  </div>
);

export default DisclaimerBox;
